import EventManager from './EventManager'
import _events from './events'

export const events = _events

export default EventManager